<template>
  <div class="dashboard-footer">
    <div class="footer-bug-button">
      <span @click="isBugModalOpen = true">
        Report A Bug
      </span>
    </div>

    <BugReportModal :isOpen="isBugModalOpen" @update:isOpen="isBugModalOpen = $event" />
  </div>
</template>

<script>
import BugReportModal from "../../UIComponents/BugReportModal.vue";

export default {
  components: { BugReportModal },
  data() {
    return {
      isBugModalOpen: false
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue